import React from 'react';
import classnames from "classnames";
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Map as LeafletMap, TileLayer, GeoJSON } from 'react-leaflet';
import L from 'leaflet';
import { Formik, Form } from 'formik';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { getParams } from '../../common/utils';
import { Circles } from "../../common/loadingComponent";
import { isNullOrUndefined, isEmpty } from '../../../store/storeFunctions';
import { MomentDate } from '../../common/momentComponent';
import { FileUpload } from '../../common/fileUpload';
import { apiGet, apiPost, apiDelete } from '../../../store/apiWrapper';
import { domainActions, propertySkDomainKeys } from '../../../store/domainStore';
import { popupActions } from '../../../store/popupStore';
import { withLocalize, Translate } from 'react-localize-redux';
import { withRouter } from 'react-router';
import { writeErr } from '../../common/logger';
import CsvExportButton from '../../common/csvExportButton';
import PopupMultiSelectButton from '../../common/popupMultiSelectButton';
import Message from '../../common/message';
import NoDataComponent from '../../common/noDataComponent';
import * as Yup from '../../common/Yup';
import PropertySkCadastreUnitParcelList from './propertySkCadastreUnitParcelList';
import UnderlinedTitle from "../../common/underlinedTitle";
import { toast } from '../../common/toast';
import BasicRow from '../../reportSections/identData/basicRow';
import BbInput from '../../styling/bbInput';
import AngleDownIcon from '../../../img/icons/BBiconsRozbalit';
import ContactsIcon from '../../../img/icons/globalReport/BBiconsGrKontaktniUdaje';
import LayersIcon from '../../../img/icons/layers';
import PlusIcon from "../../../img/icons/Plus";
import Remove from '../../../img/icons/BBiconsOdstranit';
import SvgUpravit from '../../../img/icons/Upravit';
import SvgBBiconsUlozit from '../../../img/icons/BBicons_Ulozit';
import BbCollapse from '../../common/BbCollapse';
import ColorPicker from '../../common/colorPicker'

import 'leaflet/dist/leaflet.css';
import 'leaflet.bigimage/dist/Leaflet.BigImage.min.css';
import 'leaflet.bigimage';

import './propertySk.scss';

const emptyLayer = {
    color: "#FF8800",
    shareFrom: '',
    shareTo: '',
    ownershipType: '1',
    landTypes: { all: ['2', '3', '4', '5', '6', '7', '10', '11', '13', '14'] },
    burden: null,
    fulltext: '',
    id: new Date().getTime(),
    name: '',
    parcelList: '0'
}

const SECTION = {
    layers: "layers",
    map: "map"
};

class PropertySkCadastreMap extends React.Component {
    mounted = false;
    entityId = null;
    hash = null;
    layerNo = 1;

    headerStyles = {
        'round': "circle",
        'square': ""
    };

    state = {
        layersExpanded: true,
        mapExpanded: true,
        reportHeaderStyle: 'square',
        updated: null,
        searched: null,
        apiErrors: [],
        entityUnits: null,
        mapData: null,
        foundParcels: null,
        profiles: null,
        unitsLoaded: false,
        profilesLoaded: false,
        searching: false,
        searchPostData: null,
        exportToPdfEnabled: false,
        exportPagesList: [],
        exportPages: 1,
        exportCsvNotFoundEnabled: false,
        exportCsvAllEnabled: false,
        parcelNo: '',
        parcelNotFound: false,
        moreParcelsFound: [],
        fileError: null
    }

    componentDidMount() {
        this.getProfilesList();
        this.props.ensureDomainData(propertySkDomainKeys.cadastreLandTypes);
        this.props.ensureDomainData(propertySkDomainKeys.cadastreOwnershipTypes);
        this.setState({ reportHeaderStyle: localStorage.locales_report_headers_style });
        if (!isNullOrUndefined(window.location.search) && window.location.search !== "") {
            const params = this.parseParams(getParams(window.location.search));
            if (!isNullOrUndefined(params)) {
                this.entityId = params.entityId;
                this.hash = params.hash;
                this.findUnits();
            }
        }
        this.mounted = true;
    }

    componentDidUpdate() {
        if (!this.mounted)
            return;

        if (!this.hasDomainData(propertySkDomainKeys.cadastreLandTypes))
            this.props.ensureDomainData(propertySkDomainKeys.cadastreLandTypes);
        if (!this.hasDomainData(propertySkDomainKeys.cadastreOwnershipTypes))
            this.props.ensureDomainData(propertySkDomainKeys.cadastreOwnershipTypes);
    }

    hasDomainData = (key) => !(isNullOrUndefined(this.props.domain[key]) ||
        (isNullOrUndefined(this.props.domain[key].requestResult) || this.props.domain[key].isRequesting));

    errorMessage = (err) => {
        if (!err)
            return this.props.translate('UnhappyUser.InternalServerError');
        else if (err.data && err.data.error && err.data.error.message)
            return this.props.translate(err.data.error.message)
        else
            return err.message || err.statusText || this.props.translate('UnhappyUser.InternalServerError');
    }

    render() {
        if (!this.state.unitsLoaded || !this.state.profilesLoaded)
            return <Circles />;

        if (!isNullOrUndefined(this.state.apiErrors) && this.state.apiErrors.length > 0) {
            return <>
                {this.state.apiErrors.map((e, i) => (<div key={`e${i}`} className="error-container error-container-wide" style={{ marginTop: "0.75em" }}>
                    <Message type="warning" options={{ renderInnerHtml: true }} message={this.errorMessage(e)} />
                </div>))}
            </>
        }

        if (isNullOrUndefined(this.state.entityUnits) || isNullOrUndefined(this.state.entityUnits.name) || isNullOrUndefined(this.state.entityUnits.municipalities))
            return <NoDataComponent />;

        var agentLanguage = this.props.user.authentication.profile.agentLanguage;

        return (
            <>
                {this.renderReportDateInformation()}
                <div className='card cadastre-map-root'>
                    <div className='card-body'>
                        {this.renderContent()}
                    </div>
                </div>
                <div className="disclaimer-wrapper">
                    <div className="report-component" style={{ textAlign: "center" }}><Translate id="Report.Footer" /></div>
                    <hr style={{ marginTop: "4px", marginBottom: "4px", height: "1px" }} />
                    <div className="disclaimer-gray">
                        <Translate id="PropertySk.Document.Disclaimer1" /> <Translate id={agentLanguage === 'sk-SK' ? "Report.DisclaimerSk" : "Report.DisclaimerCz"} options={{ renderInnerHtml: true }} />
                    </div>
                </div>
            </>
        )
    }

    renderReportDateInformation() {
        return (
            <div className="property-sk-query-date">
                <div>
                    <span className="bold"><Translate id="PropertySk.CadastreUnit.ReportDate" />:&nbsp;</span>
                    <span className="bold"><MomentDate value={new Date()} /></span>
                </div>
            </div>
        );
    }

    renderContent = () => {
        return (
            <>
                <div className="ident-data">
                    {!isNullOrUndefined(this.entityId) && <>
                        <BasicRow title="PropertySk.CadastreUnit.Company" value={this.state.entityUnits.name} />
                        <BasicRow title="PropertySk.CadastreUnit.CompanySeat" value={this.state.entityUnits.address} />
                        <BasicRow title="PropertySk.Search.CompanyId" value={this.state.entityUnits.companyId} />
                    </>
                    }
                    {!isNullOrUndefined(this.hash) && <>
                        <BasicRow title="PropertySk.CadastreUnit.NameAddress" value={this.state.entityUnits.name} />
                        <BasicRow title="PropertySk.CadastreUnit.BirthDate" value={this.state.entityUnits.birthDateFormated} />
                        <BasicRow title="PropertySk.CadastreUnit.BirthDateCoowner" value={this.state.entityUnits.birthDateCoownerFormated} />
                    </>
                    }
                </div>

                <Formik
                    ref={(el) => this.formRef = el}
                    enableReinitialize={false}
                    validationSchema={this.createValidationSchema()}
                    validateOnChange={true}
                    validateOnBlur={false}
                    initialValues={{
                        municipality: '',
                        cadastreUnit: '',
                        profile: '',
                        validTo: '',
                        bulkFile: undefined,
                        layers: [this.newEmptyLayer()]
                    }}
                    onSubmit={(values) => this.search(values)}
                >
                    {({ values, setFieldValue }) => (
                        <Form>
                            <div className="search-map-params">

                                {/* Municipality */}
                                <div className='layer-item-wrapper gc-1 gr-1'>
                                    <p>{this.props.translate('Search.Label.City')}</p>
                                    <BbInput type='select' options={this.municipalities()} defaultValue='' noOptionsMessage='' label=''
                                        value={this.municipalities().find(f => f.value === values.municipality)}
                                        onChange={(e) => { setFieldValue('municipality', e.value); setFieldValue('cadastreUnit', ''); setFieldValue('validTo', e.validTo); }}
                                    />
                                </div>

                                {/* Cadastral unit */}
                                <div className='layer-item-wrapper gc-1 gr-2'>
                                    <p>{this.props.translate('PropertySk.Search.CadastreUnit')}</p>
                                    <BbInput type='select' options={this.cadastreUnits(values.municipality)} defaultValue='' noOptionsMessage='' label=''
                                        value={this.cadastreUnits(values.municipality).find(f => f.value === values.cadastreUnit)}
                                        onChange={(e) => { setFieldValue('cadastreUnit', e.value); setFieldValue('validTo', e.validTo); }}
                                    />
                                </div>

                                {/* Validity Of Map Documents */}
                                {values.validTo && <div className='layer-item-wrapper gc-2 gr-3'>
                                    <p>{this.props.translate('PropertySk.CadastreMap.ValidityOfMapDocuments')}</p>
                                    <div>{values.validTo}</div>
                                </div>}

                                {/* Own List */}
                                <div className='layer-item-wrapper gc-1 gr-3'>
                                    <p>{this.props.translate('PropertySk.CadastreMap.OwnList')}</p>
                                    <div>
                                        <FileUpload className="fileupload-button" customLabel={true} name='bulkFile' accept='.csv,.xlsx,.xls'
                                            callback={(result) => setFieldValue("bulkFile", result)}
                                            resetCallback={() => setFieldValue("bulkFile", undefined)}
                                        />
                                        {this.state.fileError && <div style={{ color: 'red' }}><Translate id={this.state.fileError} /></div>}
                                    </div>
                                </div>

                                {/* Profile */}
                                <div className='layer-item-wrapper gc-2 gr-1'>
                                    <p>{this.props.translate('User.UserProfile')}</p>
                                    <BbInput type='select' options={this.profiles()} defaultValue='' noOptionsMessage='' label=''
                                        value={this.profiles().find(f => f.value === values.profile)}
                                        onChange={(e) => { setFieldValue('profile', e.value); this.applyProfile(e.value, values); }}
                                    />
                                </div>

                                {/* Profile buttons */}
                                <div className='layer-item-wrapper gc-2 gr-2 span2' style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-start' }}>
                                    <div className="ml-link color" style={{ whiteSpace: 'unset' }}>
                                        <div className="ml-link-inner">
                                            <a className={classnames({ 'link-internal': true, 'is-disabled': isEmpty(values.profile) })} onClick={() => this.allSharesValid(values.layers) && this.saveProfile(values)} >
                                                <SvgBBiconsUlozit className="ml-link-icon" />
                                                {this.props.translate('PropertySk.CadastreMap.ProfileSave')}
                                            </a>
                                        </div>
                                    </div>
                                    <div className="ml-link color" style={{ paddingLeft: '1em', whiteSpace: 'unset' }}>
                                        <div className="ml-link-inner">
                                            <a className='link-internal' onClick={() => this.allSharesValid(values.layers) && this.newProfilePopup(values)}>
                                                <PlusIcon className="ml-link-icon" />
                                                {this.props.translate('PropertySk.CadastreMap.ProfileCreate')}
                                            </a>
                                        </div>
                                    </div>
                                    <div className="ml-link color" style={{ paddingLeft: '1em', whiteSpace: 'unset' }}>
                                        <div className="ml-link-inner">
                                            <a className={classnames({ 'link-internal': true, 'is-disabled': isEmpty(values.profile) })} onClick={() => !isEmpty(values.profile) && this.deleteProfile(values)}>
                                                <Remove className="ml-link-icon" />
                                                {this.props.translate('PropertySk.CadastreMap.ProfileRemove')}
                                            </a>
                                        </div>
                                    </div>
                                    <div className="ml-link color" style={{ paddingLeft: '1em', whiteSpace: 'unset' }}>
                                        <div className="ml-link-inner">
                                            <a className={classnames({ 'link-internal': true, 'is-disabled': isEmpty(values.profile) })} onClick={() => !isEmpty(values.profile) && this.renameProfilePopup(values)}>
                                                <SvgUpravit className="ml-link-icon" />
                                                {this.props.translate('PropertySk.CadastreMap.ProfileRename')}
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {/* Layers */}
                            {this.renderSection(SECTION.layers, LayersIcon, this.props.translate('PropertySk.CadastreMap.Layers'), this.renderLayers(values, setFieldValue))}
                            {(this.state.mapData || this.state.searching) && this.renderSection(SECTION.map, ContactsIcon, this.props.translate('PropertySk.CadastreMap.MapSection'), this.renderMap())}
                            <button data-redirect="results" id="fake-submit-config" type="submit" style={{ display: "none" }} />
                        </Form>
                    )}
                </Formik>

                {!this.state.searching && this.state.foundParcels && this.state.foundParcels.length > 0 && this.renderParcelList(this.state.foundParcels, "PropertySk.CadastreMap.RecordsFound", !this.state.exportCsvAllEnabled, () => this.exportAllToCsv())}

                {this.state.mapData && this.state.mapData.notFound && this.state.mapData.notFound.length > 0 && this.renderParcelList(this.state.mapData.notFound, "PropertySk.CadastreMap.RecordsNotFound", !this.state.exportCsvNotFoundEnabled, () => this.exportNotFoundToCsv())}
            </>
        );
    }

    renderParcelList = (data, titleLabel, exportDisabled, exportFunc) => {
        return <>
            <div style={{ display: "flex", marginTop: "1em" }}>
                <div style={{ display: "flex", flex: "1 1 0px" }}>
                    <CsvExportButton style={{ margin: "1em 0" }}
                        disabled={exportDisabled}
                        onClick={() => exportFunc()}
                    />
                </div>
                <UnderlinedTitle header={this.props.translate(titleLabel)} marginBottom />
                <div style={{ flex: "1 1 0px" }} />
            </div>
            <table className="table table-report-section table-stretched property-sk-table">
                <thead>
                    <tr>
                        <th width="25%"><Translate id="PropertySk.Search.Region" /></th>
                        <th width="25%"><Translate id="PropertySk.Search.District" /></th>
                        <th width="25%"><Translate id="PropertySk.Search.Municipality" /></th>
                        <th width="25%"><Translate id="PropertySk.Search.CadastreUnit" /></th>
                        <th></th>
                        <th className="hide-on-mobile"></th>
                    </tr>
                </thead>
                <tbody>
                    {data.map((c, index) => <PropertySkCadastreUnitParcelList key={c.unit.unitId} data={c}
                        entityId={this.entityId}
                        hash={this.hash}
                        expanded={true}
                        landTypes={this.state.mapData.landTypes}
                        locations={this.state.mapData.locations}
                    />)}
                </tbody>
            </table>
        </>
    }

    renderSection = (sectionId, Icon, header, sectionBody) => {
        var expanded = this.state[sectionId + 'Expanded'];
        return <div key={this.props.sectionId} id={this.props.sectionId} data-level={1} className={classnames({ 'report-section': true, 'is-expanded': expanded })}
            ref={(el) => this.holder = el} style={{ pointerEvents: "auto" }}>
            <div
                className={classnames("header-wrap", { 'header-wrap-circle-icon': this.state.reportHeaderStyle === 'round' })}
                style={{ cursor: "pointer" }}
                onClick={e => !e.isDefaultPrevented() && this.toggleExpanded(sectionId)}
            >
                <div
                    ref={el => this.iconWrapper = el ? el : this.iconWrapper}
                    className={`${classnames(this.headerStyles[this.state.reportHeaderStyle])} top-left with-icon`}
                >
                    <Icon fill='#fff' />
                </div>
                <div className={classnames("header-body")} >
                    <div className="name">{header}</div>
                    <div className="icon-wrap">
                        <div>
                            <AngleDownIcon
                                style={{ transform: `scaleY(${expanded ? -1 : 1})`, transition: 'all .5s ease', width: '1.4em', height: '1.4em' }}
                                className={classnames('svg-standard-fill', { 'print-hidden': !expanded })}
                            />
                        </div>
                    </div>
                </div>

            </div>

            <BbCollapse className="report-section-body" tag="div" isOpen={expanded}>
                {sectionBody}
            </BbCollapse>
        </div>
    }

    renderLayers = (values, setFieldValue) => {
        return <div className="layer-container">
            {values.layers.map((l, i) => this.layerRow(values.layers, i, setFieldValue))}
            <div className="icon-wrapper" style={{ justifyContent: 'space-between' }}>
                <div className={`layer-plus-button add`} onClick={() => this.addLayer(values.layers)}>
                    <p>{this.props.translate('PropertySk.CadastreMap.Layer.Add')}</p>
                    <PlusIcon style={{ display: 'block' }} />
                </div>
                <button className={classnames('bb-button small is-primary gradient-1', { 'is-square': localStorage.locales_button_style === 'square' })} style={{ fontWeight: 600 }} type="submit" disabled={values.layers.length === 0 || values.layers.filter(f => f.landTypes.all.length === 0).length > 0 || (isEmpty(values.municipality) && isEmpty(values.cadastreUnit))}>
                    <Translate id="Search.Common.Search" />
                </button>
            </div>
        </div>
    }

    newEmptyLayer = () => { return { ...emptyLayer, id: new Date().getTime(), name: `${this.props.translate('PropertySk.CadastreMap.Layer')}${this.layerNo}`, color: this.getNewColor() } };

    getNewColor = () => {
        switch (this.layerNo % 10) {
            case 1: return '#FF8800';
            case 2: return '#4A90E2';
            case 3: return '#D0021B';
            case 4: return '#7ED321';
            case 5: return '#8B572A';
            case 6: return '#BD10E0';
            case 7: return '#F8E71C';
            case 8: return '#9B9B9B';
            case 9: return '#000000';
            case 0: return '#50E3C2';
            default: return '#FF8800';
        }
    }

    addLayer = (layers) => {
        this.layerNo++;
        layers.push(this.newEmptyLayer());
        this.setState({ updated: new Date() });
    }

    deleteLayer = (layers, i) => {
        layers.splice(i, 1);
        this.setState({ updated: new Date() });
    }

    layerRow = (layers, rowNum, setFieldValue) => {
        var layer = layers[rowNum];
        return <React.Fragment key={layer.id}>
            <div className="layer">

                {/* Color */}
                <div className='layer-item-wrapper'>
                    <div>{this.props.translate('PropertySk.CadastreMap.Color')}</div>
                    <div className='input-control'>
                        <ColorPicker onChange={(v) => layer.color = v} color={layer.color} />
                    </div>
                </div>

                {/* Name */}
                <div className='layer-item-wrapper'>
                    <p>{this.props.translate('Common.Name')}</p>
                    <BbInput
                        type='text' label=''
                        name={`layers[${rowNum}].name`}
                    />
                </div>

                {/* ParcelList condition */}
                <div className="layer-item-wrapper span2">
                    <p>{this.props.translate('PropertySk.CadastreMap.ParcelConditions')}</p>
                    <BbInput type='select' options={this.parcelConditions()} defaultValue='0' noOptionsMessage='' label=''
                        onChange={(e) => { setFieldValue(`layers[${rowNum}].parcelList`, e.value) }}
                        value={this.parcelConditions().find(f => f.value === layer.parcelList)}
                    />
                </div>

                {/* Ownership Share */}
                <div className='layer-item-wrapper gc-2'>
                    <p>{this.props.translate('PropertySk.CadastreUnit.OwnershipShare')}</p>

                    <div className='input-control'>
                        <div>&gt;=</div>
                        <div className='input-control-btn'>
                            <BbInput
                                type='text' label=''
                                name={`layers[${rowNum}].shareFrom`}
                            />
                        </div>
                        <div>,&nbsp;&lt;</div>
                        <div className='input-control-btn'>
                            <BbInput
                                type='text' label=''
                                name={`layers[${rowNum}].shareTo`}
                            />
                        </div>
                        <div>%</div>
                    </div>
                </div>

                {/* Type of Ownership Share */}
                <div className="layer-item-wrapper gc-3 span2">
                    <p>{this.props.translate('PropertySk.CadastreMap.OwnershipShareType')}</p>
                    <BbInput type='select' options={this.ownershipTypes()} defaultValue='1' noOptionsMessage='' label=''
                        onChange={(e) => { setFieldValue(`layers[${rowNum}].ownershipType`, e.value) }}
                        value={this.ownershipTypes().find(f => f.value === layer.ownershipType)}
                    />
                </div>

                {/* Landtype */}
                <div className="layer-item-wrapper gc-2">
                    <p>{this.props.translate('PropertySk.Document.LandType')}</p>
                    <BbInput type='custom' label='' custom={
                        <PopupMultiSelectButton
                            title={this.props.translate("PropertySk.Document.LandType")}
                            customDomain={this.landTypes()}
                            popupSize='extra-small'
                            selection={layer.landTypes}
                            hasRadioButtons={true}
                            handleChange={(all, parent) => {
                                setFieldValue(`layers[${rowNum}].landTypes`, { all: all, parent: parent });
                            }}
                        />
                    }
                    />
                </div>

                {/* Burden */}
                <div className='layer-item-wrapper gc-3 gr-3'>
                    <p>{this.props.translate('PropertySk.CadastreUnit.Burden')}</p>
                    <div className='' style={{ display: 'grid', gap: '1rem', gridAutoFlow: 'column', alignItems: 'center', gridTemplateColumns: '140px 1fr' }}>
                        <div>
                            <BbInput type='select' options={this.burdenTypes().values} defaultValue={this.burdenTypes().defaultValue} noOptionsMessage='' label=''
                                onChange={(e) => { setFieldValue(`layers[${rowNum}].burden`, e.value) }}
                                value={this.burdenTypes().values.find(f => f.value === layer.burden)}
                            />
                        </div>
                        <div>
                            <BbInput
                                type='text' label=''
                                name={`layers[${rowNum}].fulltext`}
                            />
                        </div>
                    </div>
                </div>

                {/* Remove Layer */}
                <div className="ml-link color gc-4 gr-3" style={{ justifySelf: 'end' }}>
                    <div className="ml-link-inner">
                        <a className='link-internal' onClick={() => this.deleteLayer(layers, rowNum)}>
                            <Remove className="ml-link-icon" />
                            <Translate id="Common.Button.Delete" />
                        </a>
                    </div>
                </div>
            </div>
        </React.Fragment>
    }

    renderMap = () => {
        var mapRef;
        if (this.state.searching)
            return <Circles />
        if (!this.state.mapData || !this.state.mapData.found)
            return <NoDataComponent />
        const center = [48.7, 19.5];
        const zoom = 11;
        const extent = this.bbox(this.state.mapData.found);
        if (isNullOrUndefined(extent))
            return <NoDataComponent />
        return <>
            <div className="parcel-map">
                <LeafletMap scrollWheelZoom={false} center={center} zoom={zoom} maxZoom={19} maxNativeZoom={19} ref={(component) => {
                    mapRef = component;
                }}
                    whenReady={(e) => {
                        e.target.fitBounds([
                            [extent[1], extent[0]],
                            [extent[3], extent[2]]]);
                        L.control.BigImage({ position: 'topright' }).addTo(e.target);
                    }}
                    onMoveEnd={(e) => this.setState({ exportToPdfEnabled: true })}
                    onZoomEnd={(e) => this.fillExportPagesList(e.target._zoom)}
                    key={`mapkey${this.state.searched}`}
                >
                    <TileLayer
                        attribution='&amp;copy <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
                        url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                        maxZoom={19}
                    />
                    {<GeoJSON data={this.state.mapData.found}
                        style={(feature) => { return { color: feature.properties.color } }}
                        onEachFeature={(feature, layer) => { layer.bindPopup(this.renderPopup(feature.properties)) }} />}
                </LeafletMap>
            </div>
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                <div style={{ display: 'flex', alignItems: 'center' }} >
                    <div>{this.props.translate('PropertySk.SearchTab.Parcel')}</div>
                    <div style={{ width: '120px', paddingLeft: '1em' }}>
                        <input className="input form-control" type='text' name='parcelNo' onChange={(e) => { this.setState({ parcelNo: e.target.value }); }} />
                    </div>
                    <button className={classnames('bb-button small is-primary gradient-1', { 'is-square': localStorage.locales_button_style === 'square' })}
                        style={{ fontWeight: 600 }} type="button"
                        onClick={() => this.searchParcel(this.state.parcelNo, mapRef)}
                    >
                        <Translate id="Search.Common.Search" />
                    </button>
                    <div style={{ color: 'red', display: this.state.parcelNotFound ? 'block' : 'none' }}><Translate id="PropertySk.CadastreMap.ParcelNotFound" /></div>
                    {this.state.moreParcelsFound.map(p =>
                        <div className="ml-link color" style={{ padding: '0 1em' }}>
                            <div className="ml-link-inner">
                                <a className='link-internal' onClick={() => this.searchParcelId(p.id, mapRef)} >
                                    {p.name}
                                </a>
                            </div>
                        </div>)}
                </div>
                <div style={{ display: 'flex', alignItems: 'center' }} >
                    <div>{this.props.translate('PropertySk.CadastreMap.ExportPages')}</div>
                    <div style={{ paddingLeft: '1em', paddingRight: '1em' }}>
                        <BbInput type='select' options={this.state.exportPagesList} defaultValue='' noOptionsMessage='' label=''
                            value={this.state.exportPagesList.find(f => f.value === this.state.exportPages)}
                            onChange={(e) => { this.setState({ exportPages: e.value, exportToPdfEnabled: true }) }}
                        />
                    </div>
                    <div className="ml-link color">
                        <div className="ml-link-inner">
                            <a className={classnames({ 'link-internal': true, 'is-disabled': !this.state.exportToPdfEnabled })} onClick={() => this.exportToPdf(mapRef)} >
                                <FontAwesomeIcon icon="file-pdf" className='search-result-icon svg-standard-fill' />
                                {this.props.translate('Common.Button.ExportPdf')}
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </>
    }

    renderPopup = (p) => {
        var odLink = "-";
        if (p.docNo > 0)
            odLink = `<u><a href="${this.createOdLink(p.unitId, p.docNo)}" target="_blank">${p.docNo}</a></u>`;
        return `<div>${this.props.translate("PropertySk.CadastreUnit.LandId")}: <b>${p.register} ${p.landId}</b></div>
        <div>${this.props.translate("PropertySk.Search.CadastreUnit")}: <b>${p.unit}</b></div>
        <div>${this.props.translate("PropertySk.CadastreUnit.OwnershipDeedNo")}: <b>${odLink}</b></div>
        <div>${this.props.translate("PropertySk.CadastreUnit.Area")}: <b>${isEmpty(p.area) ? '-' : p.area + 'm<sup>2</sup>'}</b></div>
        <div>${this.props.translate("PropertySk.CadastreUnit.ItemType")}: <b>${!isEmpty(p.landTypeId) ? this.state.mapData.landTypes[p.landTypeId.toString()] : '-'}</b></div>
        <div>${this.props.translate("PropertySk.CadastreUnit.Location")}: <b>${!isEmpty(p.locationId) ? this.state.mapData.locations[p.locationId.toString()] : '-'}</b></div>
        <div>${this.props.translate("PropertySk.CadastreUnit.OwnershipShare")}: <b>${p.share}</b></div>
        <div>${this.props.translate("PropertySk.CadastreUnit.Burden")}: <b>${this.props.translate(p.burden ? "Common.Yes" : "Common.No")}</b></div>`;
    }

    createOdLink = (cuId, odNo) => {
        if (isNullOrUndefined(cuId) || isNullOrUndefined(odNo))
            return "";

        let query = `?cadastreUnitId=${cuId}&ownershipDeedNo=${odNo}`;
        if (!isNullOrUndefined(this.entityId))
            query += `&companyId=${this.entityId}`;
        else if (!isNullOrUndefined(this.hash))
            query += `&hash=${this.hash}`;

        return `search/property-sk/ownership-deed${query}`;
    }

    municipalities = () => {
        const defaultChoice = { key: "", value: "", label: "", validTo: "" };
        if (isNullOrUndefined(this.state.entityUnits))
            return [defaultChoice];
        return [defaultChoice, ...this.state.entityUnits.municipalities.map(r => ({ key: r.id, value: r.id, label: `${r.name} (${r.district})`, validTo: r.validTo })).sort((a, b) => a.label.localeCompare(b.label))];
    }

    cadastreUnits = (municipalityId) => {
        const defaultChoice = { key: "", value: "", label: "", validTo: "" };
        if (isNullOrUndefined(this.state.entityUnits))
            return [defaultChoice];
        var res = [defaultChoice];
        var municipalities = this.state.entityUnits.municipalities;
        if (!isEmpty(municipalityId))
            municipalities = municipalities.filter(f => f.id === municipalityId);
        municipalities.forEach(m => m.units.forEach(u => res.push({ key: u.id, value: u.id, label: `${u.name} (${m.name})`, validTo: u.validTo })));
        return res.sort((a, b) => a.label.localeCompare(b.label));
    }

    profiles = () => {
        const defaultChoice = { key: "", value: "", label: "" };
        if (isNullOrUndefined(this.state.profiles))
            return [defaultChoice];
        return [defaultChoice, ...this.state.profiles.map(p => ({ key: p.profileId, value: p.profileId, label: p.name })).sort((a, b) => a.label.localeCompare(b.label))];
    }

    landTypes = () => {
        if (!this.hasDomainData(propertySkDomainKeys.cadastreLandTypes))
            return [];
        return this.props.domain[propertySkDomainKeys.cadastreLandTypes].requestResult.map(r => ({ key: r.value, value: r.value, label: r.shortening })).sort((a, b) => a.label.localeCompare(b.label));
    }

    ownershipTypes = () => {
        if (!this.hasDomainData(propertySkDomainKeys.cadastreOwnershipTypes))
            return [];
        return this.props.domain[propertySkDomainKeys.cadastreOwnershipTypes].requestResult.map(r => ({ key: r.value, value: r.value, label: r.shortening })).sort((a, b) => a.label.localeCompare(b.label));
    }

    burdenTypes = () => {

        const defaultOptions = [
            {
                key: 'NotSelected',
                value: null,
                label: this.props.translate('Common.NoSelection'),
            },
            {
                key: 'Yes',
                value: true,
                label: this.props.translate('Common.Yes.Lower'),
            },
            {
                key: 'No',
                value: false,
                label: this.props.translate('Common.No.Lower'),
            }
        ]
        return {
            defaultValue: this.props.translate('Common.NoSelection'),
            values: defaultOptions
        }
    }

    parcelConditions = () => [
        { key: '0', value: '0', label: '' },
        { key: '1', value: '1', label: this.props.translate('PropertySk.CadastreMap.ParcelCondition1') },
        { key: '2', value: '2', label: this.props.translate('PropertySk.CadastreMap.ParcelCondition2') },
        { key: '3', value: '3', label: this.props.translate('PropertySk.CadastreMap.ParcelCondition3') }
    ];

    fillExportPagesList = (zoom) => {
        var maxZoom = 19;
        var res = [];
        var maxLevel = -zoom + maxZoom + 1;
        if (maxLevel > 5)
            maxLevel = 5;
        for (var i = 1; i <= maxLevel; i++)
            res.push({ key: i, value: i, label: `${i} x ${i}` });
        var exportPages = this.state.exportPages;
        if (exportPages > maxLevel)
            exportPages = maxLevel;
        this.setState({ exportPagesList: res, exportPages: exportPages });
    }

    findUnits = () => {
        var url = '';
        var params = null;
        if (!isNullOrUndefined(this.entityId)) {
            url = `${window.babylonApiUrl}/api/cadastre-sk/find/company/units`;
            params = { entityId: this.entityId };
        }
        else if (!isNullOrUndefined(this.hash)) {
            url = `${window.babylonApiUrl}/api/cadastre-sk/find/person/units`;
            params = { hash: this.hash };
        }
        apiGet(url, params,
            (data) => {
                var errors = this.state.apiErrors;
                if (data.error)
                    errors.push(data.error);
                this.setState({ entityUnits: data.data, unitsLoaded: true, apiErrors: errors });
            },
            (err) => {
                var errors = this.state.apiErrors;
                errors.push(err);
                this.setState({ apiErrors: errors, entityUnits: null, unitsLoaded: true });
            });
    }

    getProfilesList = () => {
        apiGet(`${window.babylonApiUrl}/api/cadastre-sk/profile/list`, null,
            (data) => {
                var errors = this.state.apiErrors;
                if (data.error)
                    errors.push(data.error);
                this.setState({ profiles: data.data, profilesLoaded: true, apiErrors: errors });
            },
            (err) => {
                var errors = this.state.apiErrors;
                errors.push(err);
                this.setState({ apiErrors: errors, profiles: null, profilesLoaded: true });
            });
    }

    applyProfile = (profileId, values) => {
        if (isEmpty(profileId)) {
            this.layerNo = 1;
            values.layers = [this.newEmptyLayer()];
        }
        else {
            var profile = this.state.profiles.find(p => p.profileId === profileId);
            values.layers = this.mapLayersFromReq(profile.layers);
            this.layerNo = 0;
            values.layers.forEach(l => {
                var n = Number.parseInt(l.name.replace(this.props.translate('PropertySk.CadastreMap.Layer'), ''));
                if (!Number.isNaN(n) && n > this.layerNo)
                    this.layerNo = n;
            });
            //for multiselect reload
            document.querySelector("#fake-submit-config").click();
        }
    }

    saveProfile = (values) => {
        if (isEmpty(values.profile))
            return;

        var url = `${window.babylonApiUrl}/api/cadastre-sk/profile/${values.profile}/edit`;
        var profiles = this.state.profiles;
        var idx = profiles.findIndex(p => p.profileId === values.profile);
        var postData = {
            name: profiles[idx].name,
            layers: this.mapLayersFromForm(values)
        }
        apiPost(url, null, postData,
            (data) => {
                profiles[idx] = data.data;
                this.setState({ profiles: profiles, updated: new Date(), apiErrors: data.error ? [data.error] : [] });
                toast(this.props.translate("PropertySk.CadastreMap.ProfileSaved"), "success");
            },
            (err) => { this.setState({ apiErrors: [err] }); });
    }

    newProfilePopup = (values) => {
        this.props.showPopup('renameProfilePopup', { open: true, close: () => this.props.hidePopup(), oldName: '', saveName: (name) => this.createProfile(name, values) });
    }

    renameProfilePopup = (values) => {
        this.props.showPopup('renameProfilePopup', { open: true, close: () => this.props.hidePopup(), oldName: this.state.profiles.find(p => p.profileId === values.profile).name, saveName: (name) => this.renameProfile(name, values) });
    }

    createProfile = (name, values) => {
        if (this.state.profiles.findIndex(p => p.name.toLowerCase() === name.toLowerCase()) > -1) {
            toast(this.props.translate("PropertySk.CadastreMap.ProfileExists", { name: name }), "error");
            this.props.hidePopup();
            return;
        }
        var url = `${window.babylonApiUrl}/api/cadastre-sk/profile/create`;
        var postData = {
            name: name,
            layers: this.mapLayersFromForm(values)
        }

        apiPost(url, null, postData,
            (data) => {
                var profiles = this.state.profiles;
                profiles.push(data.data);
                values.profile = data.data.profileId;
                values.layers = this.mapLayersFromReq(data.data.layers);
                this.setState({ profiles: profiles, updated: new Date(), apiErrors: data.error ? [data.error] : [] });
            },
            (err) => { this.setState({ apiErrors: [err] }); },
            () => this.props.hidePopup());
    }

    renameProfile = (name, values) => {
        if (this.state.profiles.findIndex(p => p.name.toLowerCase() === name.toLowerCase()) > -1) {
            toast(this.props.translate("PropertySk.CadastreMap.ProfileExists", { name: name }), "error");
            this.props.hidePopup();
            return;
        }
        var url = `${window.babylonApiUrl}/api/cadastre-sk/profile/${values.profile}/rename`;

        apiPost(url, null, name,
            (data) => {
                var profiles = this.state.profiles;
                var i = profiles.findIndex(p => p.profileId === values.profile);
                profiles[i].name = data.data.name;
                this.setState({ profiles: profiles, updated: new Date(), apiErrors: data.error ? [data.error] : [] });
            },
            (err) => { this.setState({ apiErrors: [err] }); },
            () => this.props.hidePopup());
    }

    deleteProfile = (values) => {
        var url = `${window.babylonApiUrl}/api/cadastre-sk/profile/${values.profile}/remove`;

        apiDelete(url, null, null,
            (data) => {
                var profiles = this.state.profiles;
                var idx = profiles.findIndex(p => p.profileId === values.profile);
                profiles.splice(idx, 1);
                this.setState({ profiles: profiles });
                values.profile = '';
                this.layerNo = 1;
                values.layers = [this.newEmptyLayer()];
                this.setState({ updated: new Date(), apiErrors: data.error ? [data.error] : [] });
            },
            (err) => { this.setState({ apiErrors: [err] }); },
        );
    }

    toggleExpanded = (sectionId) => {
        if (sectionId === SECTION.layers)
            this.setState({ layersExpanded: (!this.state.layersExpanded) });
        else if (sectionId === SECTION.map)
            this.setState({ mapExpanded: (!this.state.mapExpanded) });
    }

    createValidationSchema = () => {
        return Yup.object().shape({
            layers: Yup.array().of(
                Yup.object().shape({
                    shareFrom: Yup.string()
                        .test('shareFrom', this.props.translate("Search.Common.Validation.WrongInput"), value => this.isValidShare(value)),
                    shareTo: Yup.string()
                        .test('shareTo', this.props.translate("Search.Common.Validation.WrongInput"), value => this.isValidShare(value)),
                    ownershipType: Yup.string().required(),
                })
            )
        });
    }

    isValidShare = (value) => value === '' || /^\d{1,3}([.,]\d{1,2})?$/.test(value);

    allSharesValid = (layers) => {
        return layers.filter(f => !this.isValidShare(f.shareFrom)).length === 0
            && layers.filter(f => !this.isValidShare(f.shareTo)).length === 0
    }

    search = (values) => {
        this.setState({ searching: true, parcelNotFound: false, moreParcelsFound: [] });
        var url = `${window.babylonApiUrl}/api/cadastre-sk/find`;

        var searchPostData = {
            entityId: this.entityId,
            hash: this.hash,
            unitId: isEmpty(values.cadastreUnit) ? null : values.cadastreUnit,
            muniId: isEmpty(values.cadastreUnit) ? values.municipality : null,
            profile: { layers: this.mapLayersFromForm(values) },
            parcelList: { file: isNullOrUndefined(values.bulkFile) ? null : values.bulkFile }
        };

        apiPost(url, null, searchPostData,
            (data) => {
                this.setState({ mapData: data.data, foundParcels: this.mapFoundParcels(data.data), updated: new Date(), searched: new Date(), searching: false, apiErrors: data.error ? [data.error] : [], searchPostData, exportToPdfEnabled: true, exportCsvNotFoundEnabled: true, exportCsvAllEnabled: true, fileError: null });
            },
            (err) => {
                var apiErrors = [err];
                var fileError = null;
                if (err && err.data && err.data.error && err.data.error.message && err.data.error.message.startsWith('UnhappyUser.Bulk.')) {
                    apiErrors = [];
                    fileError = err.data.error.message;
                }
                this.setState({ apiErrors, mapData: null, foundParcels: null, searching: false, exportToPdfEnabled: false, exportCsvNotFoundEnabled: false, exportCsvAllEnabled: false, fileError });
            });
    }

    mapFoundParcels(mapData) {
        var res = [];
        mapData.found.features.forEach(f => {
            var parcel = {
                register: f.properties.register,
                landId: f.properties.landId,
                docNo: f.properties.docNo,
                area: f.properties.area,
                landTypeId: f.properties.landTypeId,
                locationId: f.properties.locationId,
                ownershipTypeId: f.properties.ownershipTypeId,
                share: f.properties.share,
                burden: f.properties.burden
            };
            var item = res.find(p => p.unit.unitId === f.properties.unitId);
            if (isNullOrUndefined(item)) {
                var muni = this.state.entityUnits.municipalities.find(m => m.units.find(u => u.id === f.properties.unitId));
                item = {
                    unit: {
                        unitId: f.properties.unitId,
                        name: f.properties.unit,
                        municipality: muni.name,
                        district: muni.district,
                        region: muni.region
                    },
                    parcels: [parcel]
                };
                res.push(item);
            }
            else item.parcels.push(parcel);
        });
        res.forEach(r => { r.parcels.sort((a, b) => a.docNo - b.docNo) });
        return res;
    }

    searchParcel = (parcelNo, mapRef) => {
        var found = [];
        var moreParcelsFound = [];
        Object.getOwnPropertyNames(mapRef.contextValue.map._layers).forEach(i => {
            var layer = mapRef.contextValue.map._layers[i];
            if (layer && layer.feature
                && (layer.feature.properties.landId === parcelNo
                    || (!parcelNo.includes('-') && layer.feature.properties.landId.match(`^\\d-${parcelNo}$`) !== null))) {
                found.push(layer);
            }
        });

        if (found.length === 1)
            this.zoomLayer(found[0], mapRef);
        else if (found.length > 1)
            found.forEach(f => moreParcelsFound.push({ id: f.feature.properties.id, name: `${f.feature.properties.register} ${f.feature.properties.landId} ${f.feature.properties.unit}` }));

        this.setState({ parcelNotFound: found.length === 0, moreParcelsFound });
    }

    searchParcelId = (id, mapRef) => {
        Object.getOwnPropertyNames(mapRef.contextValue.map._layers).forEach(i => {
            var layer = mapRef.contextValue.map._layers[i];
            if (layer && layer.feature && layer.feature.properties.id === id) {
                this.zoomLayer(layer, mapRef);
                return;
            }
        });
    }

    zoomLayer(layer, mapRef) {
        const extent = this.bbox(layer.feature);
        mapRef.contextValue.map.flyToBounds([
            [extent[1], extent[0]],
            [extent[3], extent[2]]]);
        layer.openPopup();
    }

    exportToPdf = (mapRef) => {
        if (!this.state.exportToPdfEnabled || isNullOrUndefined(this.state.searchPostData) || !mapRef)
            return;
        this.setState({ exportToPdfEnabled: false });
        var url = `${window.babylonApiUrl}/api/cadastre-sk/find/export/pdf`;

        var bounds = mapRef.leafletElement.getBounds();

        var postData = {
            ...this.state.searchPostData,
            pages: this.state.exportPages,
            lat1: bounds._northEast.lat,
            lng1: bounds._northEast.lng,
            lat2: bounds._southWest.lat,
            lng2: bounds._southWest.lng,
            zoom: mapRef.leafletElement._zoom
        };
        apiPost(url, null, postData,
            (data) => {
                this.setState({ apiErrors: data.error ? [data.error] : [] });
            },
            (err) => { this.setState({ apiErrors: [err] }); });
    }

    exportNotFoundToCsv = () => {
        if (!this.state.exportCsvNotFoundEnabled || isNullOrUndefined(this.state.searchPostData))
            return;
        this.setState({ exportCsvNotFoundEnabled: false });
        this.exportToCsv(`${window.babylonApiUrl}/api/cadastre-sk/find/notfound/csv`);
    }

    exportAllToCsv = () => {
        if (!this.state.exportCsvAllEnabled || isNullOrUndefined(this.state.searchPostData))
            return;
        this.setState({ exportCsvAllEnabled: false });
        this.exportToCsv(`${window.babylonApiUrl}/api/cadastre-sk/find/export/csv`);
    }

    exportToCsv = (url) => {
        var postData = {
            ...this.state.searchPostData,
            language: this.props.user.language
        };
        apiPost(url, null, postData,
            (data) => {
                this.setState({ apiErrors: data.error ? [data.error] : [] });
            },
            (err) => { this.setState({ apiErrors: [err] }); });
    }

    mapLayersFromForm = (values) => {
        return values.layers.map(l => ({
            color: l.color,
            ownershipType: parseInt(l.ownershipType),
            shareFrom: isEmpty(l.shareFrom) ? null : parseFloat(l.shareFrom.replace(',', '.')),
            shareTo: isEmpty(l.shareTo) ? null : parseFloat(l.shareTo.replace(',', '.')),
            burden: l.burden,
            fulltext: l.fulltext,
            landTypes: l.landTypes.all.map(m => parseInt(m.value)),
            name: l.name,
            parcelList: parseInt(l.parcelList)
        }));
    }

    mapLayersFromReq = (layers) => {
        return layers.map(l => ({
            color: l.color,
            shareFrom: l.shareFromFormatted,
            shareTo: l.shareToFormatted,
            ownershipType: l.ownershipType.toString(),
            landTypes: { all: l.landTypes.map(m => (m.toString())), parent: [] },
            burden: l.burden,
            fulltext: isNullOrUndefined(l.fulltext) ? '' : l.fulltext,
            id: l.layerId,
            name: l.name,
            parcelList: l.parcelList.toString()
        }));
    }

    parseParams = (params) => {
        try {
            return {
                entityId: isNullOrUndefined(params.entityId) ? null : parseInt(params.entityId),
                hash: isNullOrUndefined(params.hash) ? null : params.hash
            };
        } catch {
            writeErr("Failed to parse input parameters");
            return null;
        }
    }

    //modified geojson-bbox
    bbox = (geoJson) => {
        var coords, bbox;
        if (!geoJson.hasOwnProperty('type')) return null;
        coords = this.getCoordinatesDump(geoJson);
        if (isNullOrUndefined(coords) || coords.length === 0)
            return null;
        bbox = [Number.POSITIVE_INFINITY, Number.POSITIVE_INFINITY,
        Number.NEGATIVE_INFINITY, Number.NEGATIVE_INFINITY,];
        return coords.reduce(function (prev, coord) {
            return [
                Math.min(coord[0], prev[0]),
                Math.min(coord[1], prev[1]),
                Math.max(coord[0], prev[2]),
                Math.max(coord[1], prev[3])
            ];
        }, bbox);
    }

    getCoordinatesDump = (gj) => {
        var coords = null;
        if (gj.type === 'Point') {
            coords = [gj.coordinates];
        } else if (gj.type === 'LineString' || gj.type === 'MultiPoint') {
            coords = gj.coordinates;
        } else if (gj.type === 'Polygon' || gj.type === 'MultiLineString') {
            coords = gj.coordinates.reduce((dump, part) => {
                return dump.concat(part);
            }, []);
        } else if (gj.type === 'MultiPolygon') {
            coords = gj.coordinates.reduce((dump, poly) => {
                return dump.concat(poly.reduce((points, part) => {
                    return points.concat(part);
                }, []));
            }, []);
        } else if (gj.type === 'Feature') {
            coords = this.getCoordinatesDump(gj.geometry);
        } else if (gj.type === 'GeometryCollection') {
            coords = gj.geometries.reduce((dump, g) => {
                return dump.concat(this.getCoordinatesDump(g));
            }, []);
        } else if (gj.type === 'FeatureCollection') {
            coords = gj.features.reduce((dump, f) => {
                return dump.concat(this.getCoordinatesDump(f));
            }, []);
        }
        return coords;
    }
}

export default withRouter(withLocalize(connect(
    state => ({ layout: state.layout, user: state.userContext, domain: state.domain }),
    dispatch => bindActionCreators({ ...domainActions, ...popupActions }, dispatch)
)(PropertySkCadastreMap)));
